import { render, staticRenderFns } from "./OrderEditor.vue?vue&type=template&id=252aaee4&scoped=true&"
import script from "./OrderEditor.vue?vue&type=script&lang=js&"
export * from "./OrderEditor.vue?vue&type=script&lang=js&"
import style0 from "./OrderEditor.vue?vue&type=style&index=0&id=252aaee4&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "252aaee4",
  null
  
)

export default component.exports